export default __webpack_public_path__ + "static/svg-symbols-2e290382f67c1e3a3aae1d5e2092a3f4.svg";